import { Box } from "@mui/material";
import strings from "global/constants/StringConstants";
import { kindOfFileName } from "../ContractCompareHelper";
import styles from "../ContractCompare.styles";
import t from "../ContractCompare.tokens";
import { FileGlyph } from "./ContractCompareIcons";

interface KindTileProps {
  /** The tile follows the file's extension: a real `.pdf` or `.docx`, never a guess from the list. */
  fileName: string;
  /** The smaller tile of the result's file strip. */
  small?: boolean;
}

/** The PDF / DOCX tile beside a file name. Decorative: the name beside it already says what the file is. */
const KindTile = ({ fileName, small = false }: KindTileProps) => {
  const page = strings.contractCompare.page;
  const docx = kindOfFileName(fileName) === "docx";
  const size = small ? t.kind.small.icon : t.kind.icon;
  return (
    <Box component="span" sx={styles.kind(docx, small)} aria-hidden="true">
      <FileGlyph sx={{ width: size, height: size }} />
      {docx ? page.kindDocx : page.kindPdf}
    </Box>
  );
};

export default KindTile;
